import React from 'react'
import { MessageStyled } from './ProvideExtraPersonalIdMessage.styles'
import { CustomerServiceTelephone } from '@mobi/component-library/Base/Link'
import { useHostContextFeature } from '@mobi/account/Hooks'
import { FeatureFlags } from '@mobi/settings/featureFlags'

export const ProvideExtraPersonalIdMessage = () => {
  const isAmlRiskAssessed = useHostContextFeature(FeatureFlags.AML_SIGNUP_RISK_ASSESSMENT.key)
  return (
    <MessageStyled>
      Please provide additional information such as <strong>Driver's Licence</strong>,{' '}
      <strong>Passport</strong>
      {!isAmlRiskAssessed && (
        <>
          , <strong>Medicare Card</strong>
        </>
      )}{' '}
      or call <CustomerServiceTelephone /> for assistance.
    </MessageStyled>
  )
}
